import AuthContainer from '@/components/auth/AuthContainer';
import SignInForm from '@/components/auth/SignInForm';
import TermsAndConditions from '@/components/auth/legal-links/TermsAndConditions';
import { useAuthProvider } from '@/hooks/auth/useAuthProvider';

export default function SignIn() {
	const { handleSignIn, loadingState } = useAuthProvider();

	const handleMerchantSignIn = async (username: string, password: string) => {
		await handleSignIn(username, password, false);
	};

	return (
		<AuthContainer>
			<div className="flex flex-col items-center justify-center h-full w-full p-8 mt-8">
				<div className="bg-white rounded-2xl glassy-shadow-inset-outward p-8 w-full h-2/3 flex items-center justify-center">
					<div
						className="w-full flex flex-col items-center justify-center"
						data-testid="login-page"
					>
						<p className="text-2xl text-center mb-6 mt-2 font-bold">
							Merchant Sign In
						</p>

						<div className="w-full max-w-sm">
							<SignInForm
								handleSubmit={handleMerchantSignIn}
								loading={loadingState.signIn}
							/>
						</div>
					</div>
				</div>
				<div className="w-full max-w-sm text-center mt-4">
					<TermsAndConditions />
				</div>
			</div>
		</AuthContainer>
	);
}
